import { API_CONFIG, buildApiUrl } from '../config/api';
import { ApiResponse, User, CreateUserDto, UpdateUserDto, UserListParams, UserListResponse } from '../types';
import { http, buildUrl } from './base';

/**
 * 用户管理相关 API 服务
 */
export class UserService {
  /**
   * 获取用户列表
   * @param params 查询参数
   */
  static async getUserList(params?: UserListParams): Promise<ApiResponse<UserListResponse>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.ACCOUNT.LIST);
    return http.get(url, params);
  }

  /**
   * 获取用户详情
   * @param userId 用户ID
   */
  static async getUserDetail(userId: string | number): Promise<ApiResponse<User>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ACCOUNT.DETAIL, { id: String(userId) });
    return http.get(url);
  }

  /**
   * 创建用户
   * @param data 用户数据
   */
  static async createUser(data: CreateUserDto): Promise<ApiResponse<User>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.ACCOUNT.CREATE);
    return http.post(url, data);
  }

  /**
   * 更新用户信息
   * @param userId 用户ID
   * @param data 更新数据
   */
  static async updateUser(userId: string | number, data: UpdateUserDto): Promise<ApiResponse<User>> {
    const url = buildApiUrl(API_CONFIG.ENDPOINTS.ACCOUNT.UPDATE, { id: String(userId) });
    return http.patch(url, data);
  }

  /**
   * 获取角色列表
   */
  static async getRolesList(): Promise<ApiResponse<{
    roles: {value: string, label: string}[]
  }>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.ACCOUNT.ROLES_LIST);
    return http.get(url);
  }
}

export default UserService;
